import { Utils } from "../../../../../../../services/utils.service";
import { DataCollection } from "../../../../../../infrastructure/datacollection";
import { DataContainerService } from "../../../../../../infrastructure/datacontainer.service";
import { RequestTypes } from "../../../../../../infrastructure/enums";
import { TransportData } from "../../../../../../infrastructure/transportdata";

export class BFEmployeeRecordFetchRequest {
  public static readonly FetchRequestType: string = "active_af_employee_record_fetch_request";
  
  af_employee_record_ids: number[] = [];
  zone_ids: number[] = [];
  district_ids: number[] = [];
  block_ids: number[] = [];
  bcm_post_ids: number[] = [];
  phc_ids: number[] = [];

  public MergeIntoTransportData = (td: TransportData) => {
    let coll = DataContainerService.GetInstance().GetOrCreateCollection(
      td.MainData,
      BFEmployeeRecordFetchRequest.FetchRequestType,
    ) as DataCollection;
    coll.Entries.push(this);
  };

  public FormulateTransportData = () => {
    let td = Utils.GetInstance().CreateNewTransportData(RequestTypes.Fetch);
    this.MergeIntoTransportData(td);

    return td;
  };
}
